export const API_ROUTES = {
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH_TOKEN: "/auth/refresh-token",
    ME: "/auth/me",
  },
  COMPANIES: {
    GET: (id: string) => `/companies/${id}`,
    GET_ALL: "/companies",
    GET_CRM_DOMAIN: (companyId: string) => `/companies/${companyId}/crm-domain`,
    FETCH_WHATSAPP_INFO: (companyId: string) =>
      `/companies/fetch-whatsapp-info/${companyId}`,
    REFRESH_META_LIMITS: (companyId: string) =>
      `/companies/${companyId}/refresh-meta-limits`,
    SET_REMAINING_TO_META_TIER: (companyId: string) =>
      `/companies/${companyId}/set-remaining-to-meta-tier`,
    PHONE_VERIFICATION_REQUEST_CODE: (companyId: string) =>
      `/companies/${companyId}/phone-verification/request-code`,
    PHONE_VERIFICATION_VERIFY_CODE: (companyId: string) =>
      `/companies/${companyId}/phone-verification/verify-code`,
    META_APP_CONFIG: (companyId: string) =>
      `/companies/${companyId}/meta-app-config`,
    WABA_ID: (companyId: string) => `/companies/${companyId}/waba-id`,
    PHONE_NUMBER_ID: (companyId: string) =>
      `/companies/${companyId}/phone-number-id`,
    BUSINESS_PROFILE: (companyId: string) =>
      `/companies/${companyId}/business-profile`,
  },
  CONTACTS: {
    BASE: "/contacts",
    GET_BY_USER: (cpf: string) => `/contacts/${cpf}`,
    GET_CAMPAIGNS: "/contacts/campaigns",
    GET_CAMPAIGN_VISIBLE_FIELDS: "/contacts/campaigns/visible-fields",
    GET_CAMPAIGN_EXTRA_FIELDS: (campaignId: number) =>
      `/contacts/campaigns/${campaignId}/extra-fields`,
    SET_CAMPAIGN_VISIBLE_FIELDS: (campaignId: number) =>
      `/contacts/campaigns/${campaignId}/visible-fields`,
    GET_LEADS: "/contacts/leads",
    GET_LEADS_BY_CAMPAIGN: "/contacts/leads/campaign",
  },
  LEAD_COPY: {
    RECORD: "/lead-copy/record",
    RECORD_BATCH: "/lead-copy/record-batch",
    HISTORY: "/lead-copy/history",
    IS_COPIED: (leadId: number) => `/lead-copy/is-copied/${leadId}`,
    COPIED_IDS: "/lead-copy/copied-ids",
    DELETE_HISTORY: "/lead-copy/history",
  },
  MESSAGES: {
    BASE: "/messages",
    SEND: "/messages/send",
    TEMPLATE: "/messages/template",
    TEMPLATES: "/messages/templates",
    BULK_TEMPLATE: "/messages/bulk-template",
    CALL_BUTTON: "/messages/call-button",
    CALLS_START: "/messages/calls/start",
    CALLS_TERMINATE: "/messages/calls/terminate",
    AI_DISABLED_CONVERSATIONS: "/messages/ai/disabled-conversations",
    AI_TOGGLE: (phoneNumber: string) => `/messages/ai/${phoneNumber}/toggle`,
    TEMPLATE_PARAMETERS: (templateId: string) =>
      `/messages/template/parameters/${templateId}`,
    MARK_AS_READ: (messageId: string) => `/messages/${messageId}/read`,
    MARK_AS_UNREAD: (messageId: string) => `/messages/${messageId}/unread`,
    MARK_ALL_AS_READ: (phoneNumber: string) =>
      `/messages/${phoneNumber}/read-all`,
    UNREAD_COUNT: (phoneNumber: string) =>
      `/messages/${phoneNumber}/unread/count`,
    UNREAD: (phoneNumber: string) => `/messages/${phoneNumber}/unread`,
    CAMPAIGN_TEMPLATES: {
      ASSIGN: "/messages/campaigns/templates/assign",
      GET_BY_CAMPAIGN: (campaignId: string) =>
        `/messages/campaigns/${campaignId}/templates`,
      REMOVE: (campaignId: string, templateId: string) =>
        `/messages/campaigns/${campaignId}/templates/${templateId}`,
      GET_ALL: "/messages/campaigns/templates",
      GET_USER: "/messages/campaigns/templates/user",
    },
  },
  FILE: {
    /** Upload de mídia (rota real: /messages/upload-media). */
    UPLOAD: "/messages/upload-media",
  },
} as const;
